import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from '@services/message/message.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  @Input() service: MessageService;

  constructor() { }

  ngOnInit(): void {
    this.service.clearErrors();
    this.service.clearSuccess();
  }

}
